import {
  MerchantSetupProductSchema,
  MerchantSetupProgressSchema,
} from "@redotech/redo-onboarding-db-schema";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

/**
 * Manual completion — for tasks without a derivable predicate
 * (e.g. "watch the demo video"). Tasks with predicates flip
 * automatically and should not call this.
 */
export const markMerchantSetupTaskComplete = {
  name: "markMerchantSetupTaskComplete" as const,
  input: z.object({
    product: MerchantSetupProductSchema,
    taskId: z.string().min(1).max(128),
  }),
  output: zExt.filterToValid(MerchantSetupProgressSchema),
};
